import React, { useEffect, useState } from 'react';
import { FormControlLabel, Grid, Switch, FormLabel, FormControl, Radio, RadioGroup, FormGroup, TextField } from '@mui/material';
import { EventReviewProps } from '../EventReview';
import { Event, SendInvitation } from '../../../services/Types';
import { usePermissions } from '../../../hooks/usePermissions';
import { useEventValidation } from '../../../contexts/EventValidationContext';
import { DistributionListSelector } from '../../../components/DistributionListSelector/DistributionListSelector';

export const AudienceReview: React.FC<EventReviewProps> = ({ eventData, handleEventChange }) => {
  const { eventIsUnlocked } = usePermissions(eventData || {} as Event);
  const { isFieldEnabled } = useEventValidation();
  const [distributionList, setDistributionList] = useState<string[]>([]);
  const radioButtons = [
    {
      value: SendInvitation.OWN,
      label:
        'Yes - I have my own mailing list that I will be responsible for forwarding the invitation to.'
    },
    {
      value: SendInvitation.ALL,
      label:
        'Yes - I have my own mailing list that I will email, but I also want the invitations to go through the distribution lists that I have selected.'
    },
    {
      value: SendInvitation.NOTOWN,
      label:
        'No - I will select from the WorkforceGPS distribution lists.'
    }
  ];

  //styles
  const styles = {
    distroList: {
      marginBottom: 2,
      maxHeight: 300,
      overflow: 'auto',
      width: '100%'
    }
  }

  useEffect(() => {
    if (eventData?.invitationDistributionList) {
      setDistributionList(
        typeof eventData.invitationDistributionList === 'string' 
          ? JSON.parse(eventData.invitationDistributionList)
          : eventData.invitationDistributionList
      );
    }
  }, [eventData?.invitationDistributionList]);

  return (
    <Grid container spacing={2} style={{ paddingLeft: '16px' }}>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Switch
              checked={eventData?.overHundredParticipants}
              disabled={!isFieldEnabled(!eventIsUnlocked)}
              onChange={(event, value) => {
                const syntheticEvent = {
                  target: { value: value }
                } as unknown as React.ChangeEvent<HTMLInputElement>;
                handleEventChange('overHundredParticipants')(syntheticEvent);
              }}
            />}
          label="Over 300 Participants"
        />
        <FormControl>
          <FormLabel>Do you have your own mailing list?</FormLabel>
          <RadioGroup
            value={eventData?.sendInvitation}
            onChange={(event, value) => handleEventChange('sendInvitation')(event)}
          >
            {radioButtons.map((radioButton) => (
              <FormControlLabel
                key={radioButton.value}
                value={radioButton.value}
                control={<Radio disabled={!isFieldEnabled(!eventIsUnlocked)} />}
                label={radioButton.label}
                disabled={!isFieldEnabled(!eventIsUnlocked)}
              />
            ))}
          </RadioGroup>
        </FormControl>

      </Grid>
      {eventData?.sendInvitation !== SendInvitation.OWN && <Grid item xs={6}>
        <FormControl sx={styles.distroList}>
          <FormLabel>Invitation Distribution List</FormLabel>
          <DistributionListSelector
            distributionList={distributionList}
            onDistributionListChange={(newList) => {
              const syntheticEvent = {
                target: { value: JSON.stringify(newList) }
              } as React.ChangeEvent<HTMLInputElement>;
              handleEventChange('invitationDistributionList')(syntheticEvent);
            }}
            disabled={!isFieldEnabled(!eventIsUnlocked)}
            overHundredParticipants={eventData?.overHundredParticipants}
          />
        </FormControl>
      </Grid>}
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Audience & Invitation Requests"
          value={eventData?.invitationNotes || ''}
          onChange={handleEventChange('invitationNotes')}
          disabled={!isFieldEnabled(!eventIsUnlocked)}
        />
      </Grid>
    </Grid>
  );
}; 